export default __webpack_public_path__ + "static/media/MenuUnfold.b2d55267.svg";